export const FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_FAILURE = 'FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_FAILURE';

export const findPseudonymByModuleAndCareProviderFailure = error => ({
    type: FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_FAILURE,
    payload: error,
    error: true,
});
